import { isNil } from '@uno-next/utils';
import { autoErrorHandler } from '../utils';

import type { AxiosInstance } from 'axios';

/** 设置响应拦截器 [默认] */
export function setResponseInterceptor(fetch: AxiosInstance) {
  // 响应处理
  fetch.interceptors.response.use(
    response => {
      // 若响应体 data 中 code 值为非 200 ，则接口处理异常
      if (response.data?.code !== 200) {
        autoErrorHandler(response);
      }

      return isNil(response.data?.data) ? undefined : response.data.data;
    },
    error => {
      autoErrorHandler(error.response);
      throw error;
    }
  );
}
